import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { Header, Form, Radio, Segment } from 'semantic-ui-react';
import {
  getInvoicing,
  getInvoiceLines,
  getDepositInvoice,
  getDepositPercentage,
  getDepositInvoiceCreateAction,
  getDepositInvoiceDate,
  getDepositInvoicePaymentDate,
  getDepositInvoicePaymentCondition,
  getBalanceInvoiceCreateAction,
  getBalanceInvoiceDate,
  getBalanceInvoicePaymentDate,
  getBalanceInvoicePaymentCondition,
  getBalanceInvoicePaymentFrequency,
  getInitialDuration,
  getErrors,
} from '../reducers/form';
import { fetchFormIfNeeded, updateData } from '../actions/form';
import { isFetching } from '../reducers/index';
import AASTBillDetail from 'saas/common/bill/AASTBillDetail';
import DepositInvoice from './DepositInvoice';
import BalanceInvoice from './BalanceInvoice';

export class Invoicing extends React.Component {
  componentWillMount() {
    this.props.fetchForm(this.props.contractId);
  }

  render() {
    const {
      invoicing,
      invoiceLines,
      depositInvoice,
      depositPercentage,
      depositInvoiceCreateAction,
      depositInvoiceDate,
      depositInvoicePaymentDate,
      depositInvoicePaymentCondition,
      balanceInvoiceCreateAction,
      balanceInvoiceDate,
      balanceInvoicePaymentDate,
      balanceInvoicePaymentCondition,
      balanceInvoiceType,
      balanceInvoicePaymentFrequency,
      initialDuration,
      errors,
    } = this.props;

    const radioLabel = value => {
      return value ? 'Désactiver' : 'Activer';
    };

    const onValueChanged = (field, value) => {
      this.props.updateGenericData(field, value);
    };

    if (!this.props.isFetching) {
      return (
        <Segment basic>
          <Segment>
            <Form.Field inline>
              <label>
                <Header size="medium">Facturation</Header>
              </label>
              <Radio
                toggle
                name="invoicing"
                label={radioLabel(invoicing)}
                checked={invoicing}
                onChange={this.props.updateInvoicing}
              />
            </Form.Field>
          </Segment>
          {invoicing && (
            <div>
              <Segment>
                <Header size="tiny">
                  3- Renseigner les informations tarifaires du devis-contrat
                </Header>
                <AASTBillDetail
                  lines={invoiceLines}
                  depositPercentage={parseInt(depositPercentage, 0) | 0}
                  onChange={this.props.updateInvoiceLines}
                />
              </Segment>
              <DepositInvoice
                onValueChange={onValueChanged}
                depositInvoice={depositInvoice}
                depositPercentage={depositPercentage}
                depositInvoiceCreateAction={depositInvoiceCreateAction}
                depositInvoiceDate={depositInvoiceDate}
                depositInvoicePaymentDate={depositInvoicePaymentDate}
                depositInvoicePaymentCondition={depositInvoicePaymentCondition}
                errors={errors}
              />
              <BalanceInvoice
                onValueChange={onValueChanged}
                balanceInvoiceCreateAction={balanceInvoiceCreateAction}
                balanceInvoiceDate={balanceInvoiceDate}
                balanceInvoicePaymentDate={balanceInvoicePaymentDate}
                balanceInvoicePaymentCondition={balanceInvoicePaymentCondition}
                balanceInvoiceType={balanceInvoiceType}
                balanceInvoicePaymentFrequency={balanceInvoicePaymentFrequency}
                initialDuration={initialDuration}
                errors={errors}
              />
            </div>
          )}
        </Segment>
      );
    } else {
      return (
        <div
          className="ui active loading segment"
          style={{ minHeight: '180px' }}
        />
      );
    }
  }
}

Invoicing.propTypes = {
  invoiceLines: PropTypes.array.isRequired,
  invoicing: PropTypes.bool.isRequired,
  depositInvoiceCreateAction: PropTypes.bool.isRequired,
  depositInvoiceDate: PropTypes.string,
  depositInvoicePaymentDate: PropTypes.string,
  depositInvoicePaymentCondition: PropTypes.string.isRequired,
  balanceInvoiceCreateAction: PropTypes.bool.isRequired,
  balanceInvoiceDate: PropTypes.string,
  balanceInvoicePaymentDate: PropTypes.string,
  balanceInvoicePaymentCondition: PropTypes.string.isRequired,
  balanceInvoicePaymentFrequency: PropTypes.number.isRequired,
  fetchForm: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  updateInvoicing: PropTypes.func.isRequired,
  updateDepositInvoice: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  initialDuration: getInitialDuration(state),
  invoicing: getInvoicing(state),
  invoiceLines: getInvoiceLines(state),
  depositInvoice: getDepositInvoice(state),
  depositPercentage: getDepositPercentage(state),
  depositInvoiceCreateAction: getDepositInvoiceCreateAction(state),
  depositInvoiceDate: getDepositInvoiceDate(state),
  depositInvoicePaymentDate: getDepositInvoicePaymentDate(state),
  depositInvoicePaymentCondition: getDepositInvoicePaymentCondition(state),
  balanceInvoiceCreateAction: getBalanceInvoiceCreateAction(state),
  balanceInvoiceDate: getBalanceInvoiceDate(state),
  balanceInvoicePaymentDate: getBalanceInvoicePaymentDate(state),
  balanceInvoicePaymentCondition: getBalanceInvoicePaymentCondition(state),
  balanceInvoicePaymentFrequency: getBalanceInvoicePaymentFrequency(state),
  errors: getErrors(state),
  isFetching: isFetching(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchForm: id => dispatch(fetchFormIfNeeded(id)),
  updateInvoicing: (_, value) =>
    dispatch(updateData('invoicingInformations.invoicing', value.checked)),
  updateInvoiceLines: lines =>
    dispatch(updateData('invoicingInformations.invoiceLines', lines)),
  updateDepositInvoice: value =>
    dispatch(updateData('invoicingInformations.depositInvoice', value.checked)),
  updateGenericData: (field, value) => dispatch(updateData(field, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Invoicing);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/organize/components/Invoicing.js